import React, { useContext, useState } from "react";
import { TranslationsContext } from "../../../../utils/TranslationsContext";
import { icons } from "../../../../constants";
import "../../styles/styles.css";
import "../../../../styles/global.css";
import ProfileNavBar from "./components/ProfileNavBar";
import ChangePassword from "./components/ChangePassword";
import UserInfo from "./components/UserInfo";

const Profile = ({ onCloseClick }) => {
  const { t } = useContext(TranslationsContext);
  const [activeTab, setActiveTab] = useState("user_info");

  return (
    <div className="flex-direction-row profile-modal-wrapper">
      <ProfileNavBar t={t} setActiveTab={setActiveTab} activeTab={activeTab} />

      <div className="flex-direction-column gap-24 width-100 profile-modal-content">
        <div className="flex-direction-row justify-end width-100">
          <img
            className="pointer"
            src={icons.close_gray}
            onClick={onCloseClick}
            alt="X"
          />
        </div>
        <div className="width-100">
          {activeTab === "user_info" && <UserInfo t={t} />}
          {activeTab === "change_password" && <ChangePassword t={t} />}
        </div>
      </div>
    </div>
  );
};
export default Profile;
